function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Facebook",
  transform: "translate(-0.373 0.28)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  cx: 21,
  cy: 21.5,
  rx: 21,
  ry: 21.5,
  transform: "translate(0.373 -0.28)",
  fill: "#3d5a96"
}), /*#__PURE__*/React.createElement("path", {
  id: "Facebook-2",
  "data-name": "Facebook",
  d: "M5.788,17.412H1.929V9.19H0V6.021H1.929v-1.9C1.929,1.538,3.018,0,6.112,0H8.688V3.168H7.078c-1.2,0-1.285.442-1.285,1.269l0,1.584H8.706L8.364,9.19H5.788v8.222Z",
  transform: "translate(16.868 12.515)",
  fill: "#fff"
}));

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.75cd5fd2.svg";
export { ForwardRef as ReactComponent };